import React from 'react';

import clsx from 'clsx';

import styles from './RichText.module.scss';

interface Props {
  html?: string;
  className?: string;
}

const RichText = ({ html, className, ...props }: Props) => {
  return html != null ? (
    <div
      className={clsx(styles.content, className)}
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
    />
  ) : null;
};

export default RichText;
